import { render, staticRenderFns } from "./StatusBadgeOVE.vue?vue&type=template&id=2572f74d&scoped=true&lang=pug"
import script from "./StatusBadgeOVE.vue?vue&type=script&lang=js"
export * from "./StatusBadgeOVE.vue?vue&type=script&lang=js"
import style0 from "./StatusBadgeOVE.vue?vue&type=style&index=0&id=2572f74d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572f74d",
  null
  
)

export default component.exports